// DAS-3319: the pass mark per account as one short label ("PASS" / "FAIL") for the
// "Which part pulled which way" rows, with the rule and the figures for the hover.
// The backend sentence (advice_sleeve_passmarks.evaluate) reads
// "<account>: <rule>; <window>: <figures>: <STATUS>" — it also feeds the advice prompt, so it is
// trimmed here instead of changed there.
// DAS-3361: the pass mark is judged over the last twelve months, not the calendar year, so the
// label names its window ("FAIL · 12 months", or "FAIL · since 3 Jan 2026" for an account that
// is younger than a year) — the row's own year-to-date figure next to it is a different window.

// The hover text: the rule without the internal account key and the repeated status.
export function passmarkHover(pm) {
  if (!pm || !pm.text) return '';
  let s = String(pm.text).trim();
  const prefix = `${pm.account}: `;
  if (pm.account && s.startsWith(prefix)) s = s.slice(prefix.length);
  s = s.replace(/:\s*(PASS|FAIL)\s*$/, '');
  const cut = s.indexOf('; ');
  if (cut < 0) return s;
  const rule = s.slice(0, cut);
  let figures = s.slice(cut + 2);
  if (figures.startsWith('today ')) figures = `Today: ${figures.slice(6)}`;   // pre-DAS-3361 sentence
  else figures = figures.charAt(0).toUpperCase() + figures.slice(1);
  return `Your rule for this account (strategy, section 15): ${rule}. ${figures}.`;
}

// { label, kind, hover }. kind: 'g' (pass), 'r' (fail), 'n' (no pass mark / unknown status).
export function passmarkChip(pm) {
  if (!pm) return { label: 'none', kind: 'n', hover: 'No pass mark set for this account.' };
  const kind = pm.status === 'PASS' ? 'g' : pm.status === 'FAIL' ? 'r' : 'n';
  const status = pm.status || '—';
  const label = pm.window && pm.status ? `${status} · ${pm.window}` : status;
  return { label, kind, hover: passmarkHover(pm) };
}

export default passmarkChip;
